import { isFunction } from 'lodash';
import { getNodeId } from '../../store/actionHandlers/common/adapterActions';
export default class HierarchySelectionBase {
    constructor({ nodeIsSelectable = () => true } = {}) {
        this._nodeIsSelectable = isFunction(nodeIsSelectable)
            ? nodeIsSelectable
            : () => nodeIsSelectable;
    }
    get key() {
        return 'selection';
    }
    get selectionVisuals() {
        return 'checkbox';
    }
    prepareTreeState(treeState) {
        treeState.selection = [];
        treeState.selectionStatuses = {};
    }
    getSelection(treeState) {
        return treeState.selection;
    }
    setSelection(treeState, selection, { adapter }) {
        treeState.selection = selection;
        treeState.selectionStatuses = {};
        for (const node of selection) {
            const nodeId = getNodeId(adapter, node);
            treeState.selectionStatuses[nodeId] = true;
        }
    }
    nodeIsSelected(treeState, nodeId) {
        return !!treeState.selectionStatuses[nodeId];
    }
    nodeIsSelectable(node, selection) {
        return this._nodeIsSelectable(node, selection);
    }
}
